import { NodeSelection, TextSelection } from 'prosemirror-state'

import type { Command } from 'common/Prose/Commands'
import { GapCursor } from 'common/Prose/Plugins/GapCursor/gapCursor'
import { JoinListsMetaKey } from 'common/Prose/Plugins/JoinLists'

export const mergeBackwardsIntoListItem: Command = (state, dispatch) => {
  const {
    doc,
    selection: { $from, empty },
    tr,
  } = state

  if (!empty) return false
  if ($from.pos !== $from.start() && !(state.selection instanceof GapCursor)) return false

  if (state.selection instanceof GapCursor) {
    const nodeBefore = doc.resolve($from.pos).nodeBefore
    if (!nodeBefore?.type.groups.includes('list')) return false
    if (!$from.nodeAfter) return false

    tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize)
    tr.insert($from.pos - 2, $from.nodeAfter)
    tr.setSelection(NodeSelection.create(tr.doc, $from.pos - 2))
  } else {
    const nodeBefore = doc.resolve($from.before()).nodeBefore
    if (!nodeBefore?.type.groups.includes('list')) return false

    tr.delete($from.before(), $from.after())
    tr.insert($from.before() - 3, $from.node().content)
    tr.setSelection(TextSelection.create(tr.doc, $from.before() - 3))

    // join list if we deleted content between lists
    const $listAfter = tr.doc.resolve(tr.selection.$from.after(tr.selection.$from.depth - 2))
    if ($listAfter.nodeBefore?.type === $listAfter.nodeAfter?.type) tr.setMeta(JoinListsMetaKey, $listAfter.pos) // NOTE: only one tr per command, but we want two, so delegate to a plugin
  }

  dispatch?.(tr)

  return true
}
